import React from "react";
import Pic from "../../assets/img/profile/DhruvProfilePicture.png";

import "./my-profile-pic.styles.css";

const MyProfilePic = () => {
  return (
    <div id="container">
      <div id="circle">
        <div className="img">
          <img
            className="logo"
            src={Pic}
            alt="Dhruv Agnihotri — Lead Member of Technical Staff at Salesforce"
          />
        </div>
      </div>
    </div>
  );
};

export default MyProfilePic;
